import datamethods from '../services/datamethods.js'
import {mapFields} from 'vuex-map-fields'
import Sendvalidationemail from './sendvalidationemail.vue'
export default{
    mixins:[datamethods],
    computed:{
        ...mapFields([
            
            'loggedInUser',
            'securityAppItems',
            'securityAppName',
    

        ]),
        useMFA(){
            if(window.USE_MFA==undefined){return false}
            else{return window.USE_MFA}
        }
    },
    data(){
        return{
            
        }
    },
    methods:{
        async getSecurityAppItemList(){
            let req = {
                employeeId:this.loggedInUser.user_personId,
                appName:this.securityAppName
            }
            //call api
            var response = await this.callAPI(req,'securityappitems')
            //handle response
            if(response.Successful){
              this.securityAppItems=response.SecurityAppItemList

                //check main security to see if i can even be here
                if(this.canAccess(this.securityAppName)==false){
                    this.loggedIn=false
                    this.responseMessage="You do not have access to this application."
                    console.log(this.responseMessage)
                }else{
                    

                    //mfa?
                    if(this.useMFA){
                        this.startMFA()
                    }else{
                        //we are all good
                        this.loggedIn=true
                        this.$emit('loggedin')
                    }

                    
                }

            }else{
              this.responseMessage = response.Message
            }
           
        },
        
        canAccess(itemName){
            if(itemName=='AdminHome'){return true}
            //console.log('incanaccess')
            //find it in the list. if there and canaccess=true, then yes!
            var access = false;
            if(this.securityAppItems.length==0){return false;}
            this.securityAppItems.forEach(myFunction2)
            
            function myFunction2(item, index, arr) {
                let p=arr[index]
                if(p.name==itemName){
                    
                    if(p.canAccess || !p.isSecured){
                        access=true;
                    }
                }
            } 
            return access;
        },
        canAccess_allowOverride(appName,itemName){
            var access = this.canAccess(itemName);
            
            //chance to override if false
            if(!access){
                this.$refs.override.getOverride(appName, itemName)
            }
            return access;
        },
        async securitylogin(){
            
            console.log('login')
            //validate
            if(this.username=="" || this.password==""){return}
            let req = {
                email:this.username,
                password:this.password
            }
            this.pleaseWait=true;
            console.log('login2')

            
            var response = await this.callAPI(req,'securityloginuser')
            //handle response
            if(response.Successful){
                
                this.loggedInUser=response.SecurityUser; //store user
                this.AddUserToAPI(this.loggedInUser)

                //this.loggedIn=true;
                
                this.getSecurityAppItemList()
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;
  
        },
        async securitypost_login(token){
            
            //add to api
            //console.log('secpost ' + token)
            this.AddTokenToAPI(token)
            this.token=token
            this.pleaseWait=true;
            var response = await this.callAPI(null,'securityloginuser')
            //handle response
            if(response.Successful){
                //this.currentWallet =response.wallet;
                
                this.loggedInUser=response.SecurityUser; //store user
                this.AddUserToAPI(this.loggedInUser)
                //this.loggedIn=true;

                this.getSecurityAppItemList()
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;
  
        },

        //MFA methods
        startMFA(){
            //pop a send validation email... special popup. send/cancel.
            this.$refs.confirmValidationEmailPopup.Show()
            
            
            //when we get back to start...if url includes validatetoken, 
            
        },
        async sendValEmail(){
            //send means call endpoint validateemail with personid email, appurl

            let req = {
                email:this.username,
                personId:this.loggedInUser.user_personId
            }
            this.pleaseWait=true;

            
            var response = await this.callAPI(req,'validateemail')
            //handle response
            if(response.Successful){
                
  
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;

        },
        async checkValEmail(token){
            //  then send it in to check. if fail, message. if pass, 
            //  now we set loggedin to true and emit logged in
            let req = {
                email:this.username,
                personId:this.loggedInUser.user_personId,
                token:token
            }
            this.pleaseWait=true;

            
            var response = await this.callAPI(req,'checkemailvalidation')
            //handle response
            if(response.Successful){
                this.loggedInUser.user_personId=response.ResponseInteger
                this.loggedIn=true
                this.$emit('loggedin')
  
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;

        }
       /*  overrideSuccessful(){
            console.log('override!!!')
        }, */
    }

}